<template>
    <div>
        <div
            style="position: -webkit-sticky; position: sticky; top: 48px; background-color:white; z-index:1;"
        >
            <div class="d-flex align-center">
                <v-text-field
                    v-model.trim="search_query"
                    label="Szukaj"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                ></v-text-field>

                <v-spacer></v-spacer>

                <span class="body-2 text--secondary d-none d-sm-inline">{{ from }}-{{ to }} z {{ total }}</span>

                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-bind="attrs" v-on="on" :disabled="is_page_first" @click="prevPage">
                            <v-icon>mdi-chevron-left</v-icon>
                        </v-btn>
                    </template>
                    <span>Poprzednia strona</span>
                </v-tooltip>

                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-bind="attrs" v-on="on" :disabled="is_page_last" @click="nextPage">
                            <v-icon>mdi-chevron-right</v-icon>
                        </v-btn>
                    </template>
                    <span>Następna strona</span>
                </v-tooltip>
            </div>

            <div class="d-flex align-center mb-3 px-1">
                <v-btn
                    color="secondary"
                    text
                    small
                    rounded
                    :disabled="!unitsToUpdateAvailabilityDate.length"
                    @click="showUnitAvailabilityDateUpdateDialog"
                >
                    <v-icon class="mr-2">mdi-calendar</v-icon>
                    <template v-if="!is_mobile">Ustaw datę dostępności</template>
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                    :text="!showOnlyMissingComponents"
                    small
                    rounded
                    :color="showOnlyMissingComponents ? 'accent' : 'secondary'"
                    @click="showOnlyMissingComponents = !showOnlyMissingComponents"
                >
                    <v-icon class="mr-2">mdi-{{ showOnlyMissingComponents ? 'close' : 'package-variant' }}</v-icon>
                    {{ showOnlyMissingComponents ? 'Wyświetlam' : 'Wyświetl' }} braki
                </v-btn>
            </div>
            <hr class="mb-1">
        </div>

        <loading-message v-if="unitIndexing" :message="loading_message" class="my-5"></loading-message>
        <v-simple-table v-else-if="units.length">
            <template v-slot:default>
                <tbody>
                <tr
                    v-for="unit in units"
                    :key="unit.UnitID"
                >
                    <th class="text-no-wrap">
                        <v-checkbox
                            v-model="unitsToUpdateAvailabilityDate"
                            :label="getCheckboxLabel(unit)"
                            :value="unit.UnitID"
                        ></v-checkbox>
                    </th>
                    <td :class="{'error--text': unit.OnTheShelfCount <= 0}">
                        <v-icon :color="unit.OnTheShelfCount <= 0 ? 'error' : 'default'">mdi-package-variant</v-icon>
                        Stan: <strong>{{ unit.Content ? unit.Content.Qty : 0 }}</strong> /
                        Na regale: <strong>{{ unit.OnTheShelfCount }}</strong>
                    </td>
                    <td>
                        <v-tooltip bottom v-if="unit.OnTheShelfCount < 1 && !unit.AvailableAt">
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon color="error" v-bind="attrs" v-on="on">mdi-alert</v-icon>
                            </template>
                            Brak komponentów 'Na Regale'. Proszę ustawić datę dostępności!
                        </v-tooltip>
                    </td>
                    <td class="text-right">
                        <template v-if="unit.AvailableAt">
                            <small class="text--secondary d-block">Dostępny od:</small>
                            <v-icon class="mr-2">mdi-calendar</v-icon> {{ unit.AvailableAt }}
                        </template>
                        <template v-else>-</template>
                    </td>
                </tr>
                </tbody>
            </template>
        </v-simple-table>
        <v-alert
            v-else
            border="left"
            colored-border
            type="info"
            elevation="1"
        >{{ empty_message }}</v-alert>

        <v-dialog
            v-if="unitsToUpdateAvailabilityDate.length"
            v-model="unitsAvailabilityDateUpdateDialog"
            persistent
            width="500"
        >
            <v-card>
                <v-card-title class="headline grey lighten-2 mb-5">
                    {{ unitsAvailabilityDateUpdateDialogTitle }}
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        @click="hideUnitAvailabilityDateUpdateDialog"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text>
                    <v-menu
                        v-model="availableAtDatePicker"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="AvailableAt"
                                :label="unitsAvailabilityDateUpdateDialogTitle"
                                prepend-icon="mdi-calendar"
                                readonly
                                clearable
                                v-bind="attrs"
                                v-on="on"
                                :error="$store.getters.hasValidationError('AvailableAt')"
                                :error-messages="$store.getters.validationError('AvailableAt')"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="AvailableAt"
                            @input="availableAtDatePicker = false"
                        ></v-date-picker>
                    </v-menu>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        rounded
                        color="success"
                        @click="unitAvailabilityDateBulkUpdate"
                        :loading="unitsAvailabilityDateUpdating"
                    >Zapisz</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import LoadingMessage from "../../../components/LoadingMessage";

export default {
    name: "Units",
    components: {
        LoadingMessage,
    },
    data() {
        return {
            search_query: "",
            showOnlyMissingComponents: false,

            unitIndexing: false,
            units: [],

            unitsAvailabilityDateUpdating: false,
            unitsToUpdateAvailabilityDate: [],
            AvailableAt: null,
            unitsAvailabilityDateUpdateDialog: false,
            availableAtDatePicker: false,

            // pagination
            page: 1,
            last_page:1,
            from: 0,
            to: 0,
            total: 0,
        };
    },

    computed: {
        is_mobile() {
            return this.$vuetify.breakpoint.mobile;
        },

        is_page_first() {
            return this.page === 1;
        },

        is_page_last() {
            return this.page === this.last_page;
        },

        loading_message() {
            return ! this.search_query
                ? "Pobieranie listy komponentów..."
                : "Wyszukiwanie komponentów...";
        },

        empty_message() {
            return ! this.search_query
                ? "Brak komponentów"
                : "Nie znaleziono komponentów pasujących do podanej frazy";
        },
        unitsAvailabilityDateUpdateDialogTitle() {
            return 'Data dostępności ' +
                (this.unitsToUpdateAvailabilityDate.length === 1 ? 'komponentu' : 'komponentów');
        },
    },

    methods: {
        loadPage () {
            //If any request_search is currently in progress, cancel it!
            if (this.$store.state.sources.unit_index) {
                this.$store.state.sources.unit_index.cancel();
            }

            //Run debouncedFetch
            this.debouncedUnitIndexFast();
        },
        nextPage: function () {
            if (this.page < this.last_page) {
                this.page++;
                this.loadPage();
            }
        },
        prevPage: function () {
            if (this.page > 1) {
                this.page--;
                this.loadPage();
            }
        },
        resetPage () {
            this.page = 1;
        },
        unitIndex () {
            this.unitIndexing = true;

            this.$store.dispatch('unitIndex', {
                page: this.page,
                search_query: this.search_query,
                missing_only: this.showOnlyMissingComponents ? 1 : 0
            }).then(response => {
                if(response.status === 200) {
                    this.units = response.data.data;
                    this.unitsToUpdateAvailabilityDate = [];
                    this.page = response.data.meta.current_page ?? 1;
                    this.last_page = response.data.meta.last_page ?? 1;
                    this.from = response.data.meta.from ?? 0;
                    this.to = response.data.meta.to ?? 0;
                    this.total = response.data.meta.total;
                } else {
                    this.$store.commit("showSnackbarError", "Błąd ładowania listy komponentów.");
                }
            })
                .catch(error => {})
                .then(() => {
                    this.unitIndexing = false;
                });
        },
        unitAvailabilityDateBulkUpdate () {
            this.unitsAvailabilityDateUpdating = true;

            this.$store.dispatch('unitAvailabilityDateBulkUpdate', {
                UnitIDs: this.unitsToUpdateAvailabilityDate,
                AvailableAt: this.AvailableAt
            }).then(response => {
                if (response.status === 204) {
                    this.unitsToUpdateAvailabilityDate = [];
                    this.hideUnitAvailabilityDateUpdateDialog();
                    this.$store.commit("showSnackbarSuccess", "Zapisano.");
                    this.unitIndex();
                } else {
                    this.$store.commit("showSnackbarError", "Błąd zapisu.");
                }
            })
                .catch(error => {})
                .then(() => {
                    this.unitsAvailabilityDateUpdating = false;
                });
        },
        getCheckboxLabel (unit) {
            return (unit.System ? unit.System.SystemName : "-") +" | "+
            (unit.Block ? unit.Block.BlockName : "-") +" | "+
            (unit.Component ? unit.Component.ComponentName : "-") +" | "+
            (unit.UnitColor ? unit.UnitColor.UnitColorName : "-");
        },
        showUnitAvailabilityDateUpdateDialog() {
            this.unitsAvailabilityDateUpdateDialog = true;
        },
        hideUnitAvailabilityDateUpdateDialog() {
            this.unitsAvailabilityDateUpdateDialog = false;
        },
    },

    created() {
        this.debouncedUnitIndex = _.debounce(this.unitIndex, 900);
        this.debouncedUnitIndexFast = _.debounce(this.unitIndex, 300);

        this.unitIndex();
    },

    watch: {
        search_query: function (new_value, old_value) {
            this.resetPage();

            //If any request_search is currently in progress, cancel it!
            if (this.$store.state.sources.unit_index) {
                this.$store.state.sources.unit_index.cancel();
            }

            //Run debouncedFetch
            this.debouncedUnitIndex();
        },
        showOnlyMissingComponents: function (new_value, old_value) {
            this.resetPage();

            //If any request_search is currently in progress, cancel it!
            if (this.$store.state.sources.unit_index) {
                this.$store.state.sources.unit_index.cancel();
            }

            //Run debouncedFetch
            this.debouncedUnitIndexFast();
        },
    }
}
</script>

<style scoped>
tbody th:first-child, tbody td:nth-child(2) {
    width:10px;
}
tbody td:nth-child(2), td:last-child {
    white-space: nowrap;
}
</style>
